import { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loading from "shared/components/Spin";
import { StoreContext } from "shared/store";
import { SCREENS } from "utils/constants";

// The access token is delivered exclusively through the httpOnly session cookies
// set by the API (`kayros_at` / `kayros_sid`) and is never exposed to JS. We only
// persist the non-secret "session" sentinel so route guards know the user is
// authenticated; every request then relies on the credentialed cookie.
const SESSION_SENTINEL = "session";

const ZitadelCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setAccessToken } = useContext(StoreContext);

  useEffect(() => {
    const error = searchParams.get("error");
    if (error) {
      navigate(SCREENS.AUTH.SIGN_IN.path, { replace: true });
      return;
    }

    setAccessToken({ accessToken: SESSION_SENTINEL });
    navigate(SCREENS.AUTH.SIGN_IN.path, { replace: true });
  }, [navigate, searchParams, setAccessToken]);

  return <Loading />;
};

export default ZitadelCallback;
